module.exports = __webpack_public_path__ + "img/img6.3c0c7549.svg";